import decimal from './decimal';

interface Params {
  oldValue?: number | null;
  newValue?: number | null;
}

export const calculateChange = ({ oldValue, newValue }: Params) => {
  if (
    oldValue === undefined ||
    newValue === undefined ||
    oldValue === null ||
    newValue === null
  ) {
    return undefined;
  }

  return decimal(newValue)?.minus(oldValue).toNumber();
};
